var OCS = OCS || {};
OCS.Functions = OCS.Functions || {};
OCS.Live = OCS.Live || {};
OCS.Functions.is_fetch_supported = function () {
    /* istanbul ignore next */
    try {
        if (OCS.is_worker) {
            if (typeof (self) !== 'undefined') {
                return !!self.fetch;
            }
        } else {
            if (typeof (window) !== 'undefined') {
                return !!window.fetch;
            }
        }
    } catch (e) {}
    /* istanbul ignore next */
    return false;

};
OCS.Functions.get_ajax_manager = function (ops) {
    if (!OCS.Live.OCSAjaxManager) {
        OCS.Live.OCSAjaxManager = new OCS.Classes.OCSAjaxManager(ops);
    }
    return OCS.Live.OCSAjaxManager;
};